<div class="container">
    <div class="tu-precio">
        <h2 class="primary-color titulo-principal">{{'mejor-precio.enhorabuena' | translate}}</h2>
        <h3 class="primary-color titulo-secundario">{{'mejor-precio.titulo' | translate}}</h3>
        <div class="capital-con-icono">
            <div [formGroup]="formCapital" class="input-capital">
                <div class="input-row centered-elements">
                    <span id="icono-corazon" class="material-symbols-outlined primary-color">
                        ecg_heart
                    </span>
                    <div class="flex-container" [ngClass]="{'show-input': mostrarInputOtroCapital}">
                        <select id="elegir-capital" name="elegir-capital" formControlName="cobertura"
                            class="input-form-control" (change)="actualizarCapitalCobertura()">
                            <option *ngFor="let opcion of opcionesCapital" [value]="opcion">{{ opcion |
                                currencyEuroSinDecimales }}</option>
                            <option value="otro">{{'mejor-precio.opcion.modificar-capital.otro' | translate}}</option>
                        </select>
                        <input class="otro-capital input-form-control" type="number" *ngIf="mostrarInputOtroCapital"
                            formControlName="otroCapital" placeholder="Introduce el capital"
                            [ngClass]="{'errors-seguro': formCapital.controls['otroCapital'].invalid && (formCapital.controls['otroCapital'].touched || formCapital.controls['otroCapital'].dirty) && formCapital.controls['otroCapital'].errors}">
                    </div>
                    <div>
                        <h2 class="primary-color capital-bold">{{'mejor-precio.capital-asegurado' | translate}}</h2>
                    </div>
                </div>
                <div *ngIf="formCapital.controls['otroCapital'].invalid && (formCapital.controls['otroCapital'].touched || formCapital.controls['otroCapital'].dirty) && formCapital.controls['otroCapital'].errors"
                    class="content-validacion-form mt-0">
                    <div [translate]="'otro-capital-cobertura.error'"
                        [translateParams]="{value: maxCapital | currencyEuroSinDecimales}"></div>
                </div>
            </div>
        </div>
        <h2 class="bold fallecimiento-causa-text">{{'ver-precio.titulo.fallecimiento.causa' | translate}}</h2>

        <p class="precio-mes"><span id="desde">{{
                poliza.precioMensual |
                currencyEuroSinDecimales }}</span> {{'ver-precio.titulo.fallecimiento.mes' | translate}}</p>
    </div>
    <h3 id="incluido-poliza">{{'mejor-precio.titulo.incluido-poliza' | translate}}</h3>
    <div class="coberturas">
        <div class="fallecimiento-accidente">
            <img src="../../../../assets/images/icons/cayendo.png" alt="">
            <div class="accidente-info">
                <p class="bold cobertura-texto">{{'mejor-precio.titulo.fallecimiento.accidente' | translate}}</p>
                <button class="documento" (click)="abrirModalFallecimiento()">
                    <span class="material-symbols-outlined primary-color">
                        info
                    </span>
                </button>
            </div>
            <p class="primary-color"><span class="capital-asegurado">{{ (poliza.capitalCobertura *
                    2).toLocaleString('es-ES') }}</span> € {{'mejor-precio.capital-asegurado' | translate}}</p>
        </div>
        <div class="invalidez-permanente">
            <img src="../../../../assets/images/icons/discapacitado.png" alt="">
            <div class="accidente-info">
                <p class="bold cobertura-texto">{{'mejor-precio.titulo.accidente.total-parcial' | translate}}</p>
                <button class="documento" (click)="abrirModalIncapacidad()">
                    <span class="material-symbols-outlined primary-color">
                        info
                    </span>
                </button>
            </div>
            <p class="primary-color"><span class="capital-asegurado">{{ (poliza.capitalCobertura *
                    2).toLocaleString('es-ES') }}</span> € {{'mejor-precio.capital-asegurado' | translate}}</p>
        </div>
    </div>
    <div class="documentos-capital">
        <div class="documentos-poliza">
            <div class="documentos">
                <button class="documento" (click)="descargarPdfPresupuesto()">
                    <span class="material-symbols-outlined primary-color">
                        file_save
                    </span>
                    <p>{{'mejor-precio.guardar.presupuesto' | translate}}</p>
                </button>
                <button class="documento" (click)="abrirModalInformacionLegal()">
                    <span class="material-symbols-outlined primary-color">
                        info
                    </span>
                    <p>{{'mejor-precio.info.legal' | translate}}</p>
                </button>
            </div>
        </div>
    </div>
    <div class="botones-regresar-contratar">
        <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'" [estilo]="'border'"
            [routerLink]=[CONSTANTES.PATH_COLECTIVOS_4_PREGUNTAS_COLECTIVOS]>
        </app-generic-field-button-next-back>
        <app-generic-field-button-next-back class="mr-1" [direccion]="'next'" [texto]="'Contratar'" [estilo]="'simple'"
            (eventoClick)="contratar()">
        </app-generic-field-button-next-back>
    </div>
</div>